var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 16.25C19.5208 16.25 22.375 13.3958 22.375 9.875C22.375 6.35418 19.5208 3.5 16 3.5C12.4792 3.5 9.625 6.35418 9.625 9.875C9.625 13.3958 12.4792 16.25 16 16.25Z",
    stroke: "#00842F",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 26.7896C5.5 24.0048 6.60625 21.3341 8.57538 19.3649C10.5445 17.3958 13.2152 16.2896 16 16.2896C18.7848 16.2896 21.4555 17.3958 23.4246 19.3649C25.3938 21.3341 26.5 24.0048 26.5 26.7896",
    stroke: "#00842F",
    strokeWidth: 2.5,
    strokeLinecap: "square"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.c6d855ce.svg";
export { ForwardRef as ReactComponent };